import {
  ACCOUNT_MODIFY_REQUEST,
  ACCOUNT_MODIFY_SUCCESS,
  ACCOUNT_MODIFY_FAILURE,
  ACCOUNT_CLEAR_STATUS,
  ACCOUNT_CONTACT_PREF_GET_REQUEST,
  ACCOUNT_CONTACT_PREF_GET_SUCCESS,
  ACCOUNT_CONTACT_PREF_GET_FAILURE,
  ACCOUNT_CONTACT_PREF_UPDATE_REQUEST,
  ACCOUNT_CONTACT_PREF_UPDATE_SUCCESS,
  ACCOUNT_CONTACT_PREF_UPDATE_FAILURE,
} from '../actions/account';

const initialState = {
  status: {},
  statusResponse: {},
  preferences: {},
  prefOrigin: {},
  accountContactPrefGetError: undefined
};

export default function supplemental(state = initialState, action = null) {
  switch (action.type) {
    case ACCOUNT_MODIFY_REQUEST:
      return Object.assign({}, state, { status: ACCOUNT_MODIFY_REQUEST });
    case ACCOUNT_MODIFY_SUCCESS:
      return Object.assign({}, state, { status: ACCOUNT_MODIFY_SUCCESS, statusResponse: action.payload });
    case ACCOUNT_MODIFY_FAILURE:
      return Object.assign({}, state, { status: ACCOUNT_MODIFY_FAILURE, statusResponse: action.error });
    case ACCOUNT_CLEAR_STATUS:
      return Object.assign({}, state, { status: {}, statusResponse: {} });
    case ACCOUNT_CONTACT_PREF_GET_REQUEST:
      return Object.assign({}, state, { status: ACCOUNT_CONTACT_PREF_GET_REQUEST, prefOrigin: action.origin });
    case ACCOUNT_CONTACT_PREF_GET_SUCCESS:
      return Object.assign({}, state, { status: ACCOUNT_CONTACT_PREF_GET_SUCCESS, preferences: action.payload, prefOrigin: {} });
    case ACCOUNT_CONTACT_PREF_GET_FAILURE:
      return Object.assign({}, state, { status: ACCOUNT_CONTACT_PREF_GET_FAILURE, preferences: {}, prefOrigin: {}, accountContactPrefGetError: action.error });
    case ACCOUNT_CONTACT_PREF_UPDATE_REQUEST:
      return Object.assign({}, state, { status: ACCOUNT_CONTACT_PREF_UPDATE_REQUEST, prefOrigin: action.origin });
    case ACCOUNT_CONTACT_PREF_UPDATE_SUCCESS:
      return Object.assign({}, state, { status: ACCOUNT_CONTACT_PREF_UPDATE_SUCCESS, prefOrigin: {} });
    case ACCOUNT_CONTACT_PREF_UPDATE_FAILURE:
      return Object.assign({}, state, { status: ACCOUNT_CONTACT_PREF_UPDATE_FAILURE, prefOrigin: {} });
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/reducers/account.js